/* istanbul ignore file */
import React, { useState } from 'react';
import { Button, ButtonProps } from '../ui/mui-builder/Button/Button';
import { FormFieldsData } from './FormContext';
import { AfterSubmitProps } from './formHelper';
import ModalForm from './ModalForm';
import { Modal } from 'framework/ui/ui-builder';
import { ValidationSchema } from 'validation-schema-library';
import { Breakpoint, SxProps } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import { ResourceData } from 'framework/crud';

type ModalFormButtonProps = {
  color?: BasicColors;
  label?: React.ReactNode;
  getValidationSchemaFunc?: () => Promise<ValidationSchema>;
  isVisible?: boolean;
  outline?: boolean;
  formTitle: Nullable<string>;
  afterSubmit?: AfterSubmitProps<(response: object) => void>;
  submitFormFunc: (values: FormFieldsData) => Promise<object>;
  initialData?: FormFieldsData;
  handleDirty?: boolean;
  disabled?: boolean;
  children: React.ReactElement | React.ReactElement[] | React.ReactNode;
  modalSize?: Breakpoint;
  paperStyles?: Dictionary<any>;
  paperSx?: SxProps<Theme>;
  isHideDefaultButtons?: boolean;
  sxButton?: SxProps;
  getDataFunc?: Nullable<() => Promise<ResourceData>>;
  size?: 'small' | 'medium' | 'large';
  backdrop?: boolean | 'static';
  isCloseAfterSubmit?: boolean;
  closeEffect?: () => void;
  buttonProps?: ButtonProps;
  submitButtonText?: string;
};

const ModalFormButton = ({
  isVisible = true,
  formTitle,
  afterSubmit,
  getValidationSchemaFunc,
  submitFormFunc,
  initialData,
  children,
  label,
  color = 'primary',
  outline,
  handleDirty = true,
  disabled = false,
  modalSize,
  paperStyles,
  paperSx,
  isHideDefaultButtons = false,
  sxButton,
  getDataFunc,
  size,
  backdrop = 'static',
  isCloseAfterSubmit = true,
  closeEffect,
  submitButtonText,
  buttonProps,
}: ModalFormButtonProps) => {
  const [modalOpen, setModalOpen] = useState(false);

  const closeModal = () => {
    setModalOpen(false);
    closeEffect && closeEffect();
  };

  let result;
  if (isVisible) {
    result = (
      <>
        <Button
          variant={outline ? 'outlined' : undefined}
          color={color}
          onClick={(e: React.MouseEvent<HTMLElement>) => {
            setModalOpen(true);
            (e.target as HTMLElement).blur();
          }}
          disabled={disabled}
          sx={sxButton}
          size={size}
          {...buttonProps}
        >
          {label}
        </Button>
        <Modal
          backdrop={backdrop}
          isOpen={modalOpen}
          title={formTitle}
          onToggle={closeModal}
          hasCancelButton
          className="form-modal"
          modalSize={modalSize}
          paperStyles={paperStyles}
          paperSx={paperSx}
        >
          <ModalForm
            getValidationSchemaFunc={getValidationSchemaFunc}
            modalOpen={modalOpen}
            closeModal={closeModal}
            handleDirty={handleDirty}
            submitFormFunc={submitFormFunc}
            afterSubmit={afterSubmit}
            initialData={initialData}
            isHideDefaultButtons={isHideDefaultButtons}
            getDataFunc={getDataFunc}
            isCloseAfterSubmit={isCloseAfterSubmit}
            submitButtonText={submitButtonText}
          >
            {children}
          </ModalForm>
        </Modal>
      </>
    );
  }
  return <>{result}</>;
};

export default ModalFormButton;
